import { IssueStatus } from '@cims-online/shared'
import { Issue } from '../../../IssueTrackerContext/types'

const Title: React.FC<Issue> = ({ statusId, formattedNumber }) => {
  let children
  if (statusId === IssueStatus.PendingResponse.id)
    children = `Respond to ${formattedNumber}`
  else if (statusId === IssueStatus.PendingDisposition.id)
    children = `Give Disposition on ${formattedNumber}`
  else if (statusId === IssueStatus.PendingClosure.id)
    children = `Close ${formattedNumber}`
  return <>{children}</>
}

export default Title
